/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardQueryVariables = {
    entityReference: string;
    startDate: string;
    endDate: string;
};
export type DashboardQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Dashboard_viewer">;
    };
};
export type DashboardQuery = {
    readonly response: DashboardQueryResponse;
    readonly variables: DashboardQueryVariables;
};



/*
query DashboardQuery(
  $entityReference: String!
  $startDate: Date!
  $endDate: Date!
) {
  viewer {
    ...Dashboard_viewer
  }
}

fragment AccountSelector_viewer on Viewer {
  user {
    id
    username
    roles {
      name
      id
    }
  }
}

fragment DashboardDataBlock_category on DashboardCategorySales {
  category
  yesterdaysSalesToDate
  currentMonthToDate
  lastMonthMonthToDate
  lastMonth
  allZero
}

fragment DashboardDataViewer_viewer on Viewer {
  ...AccountSelector_viewer
  user {
    roles {
      name
      id
    }
    id
  }
  report {
    commissionSummary(entityReference: $entityReference) {
      ...DashboardSummary_commissionSummary
    }
    detailedSalesReportDateRange(entityReference: $entityReference, startDate: $startDate, endDate: $endDate) {
      HUBAcc
      HUB
      SpokeAcc
      Spoke
      TotalSales
      Airtime_Sales
      Data_Sales
      Electricity_Sales
      Entertainment_Sales
      Ticketing_Sales
      Billpayments_Sales
      Other_Sales
    }
    detailedSalesReport(entityReference: $entityReference) {
      ...DashboardDropDown_report
      ...DashboardProductsReport_report
      entity
      categories {
        airtime {
          categories {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          totalRollup {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          transactions {
            transactionCount
            transactionAmount
          }
        }
        data {
          categories {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          totalRollup {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          transactions {
            transactionCount
            transactionAmount
          }
        }
        entertainment {
          categories {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          totalRollup {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          transactions {
            transactionCount
            transactionAmount
          }
        }
        ticketing {
          categories {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          totalRollup {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          transactions {
            transactionCount
            transactionAmount
          }
        }
        billPayments {
          categories {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          totalRollup {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          transactions {
            transactionCount
            transactionAmount
          }
        }
        electricity {
          categories {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          totalRollup {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          transactions {
            transactionCount
            transactionAmount
          }
        }
        other {
          categories {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          totalRollup {
            isNull
            name
            key
            yesterdaysSalesToDate
            currentMonthToDate
            lastMonthMonthToDate
            lastMonth
          }
          transactions {
            transactionCount
            transactionAmount
          }
        }
      }
    }
  }
  ...EntityCombobox_viewer
  ...DashboardNegativeSummary_viewer
  dashboard(entityReference: $entityReference) {
    hub {
      account
      ...DashboardSearch_account
      ...DashboardSummary_accountSummary
      categories {
        category
        ...DashboardDataBlock_category
        ...DashboardSummary_totalSales
      }
    }
    rollup {
      account
      ...DashboardSearch_account
      ...DashboardSummary_accountSummary
      categories {
        category
        ...DashboardDataBlock_category
        ...DashboardSummary_totalSales
      }
    }
    spokes {
      account
      ...DashboardSearch_account
      ...DashboardSummary_accountSummary
      categories {
        category
        ...DashboardDataBlock_category
        ...DashboardSummary_totalSales
      }
    }
  }
}

fragment DashboardDropDown_category on DetailedSalesReportCategory {
  categories {
    isNull
    name
    key
    yesterdaysSalesToDate
    currentMonthToDate
    lastMonthMonthToDate
    lastMonth
  }
  totalRollup {
    isNull
    name
    key
    yesterdaysSalesToDate
    currentMonthToDate
    lastMonthMonthToDate
    lastMonth
  }
}

fragment DashboardDropDown_report on DetailedSalesReport {
  categories {
    airtime {
      ...DashboardDropDown_category
    }
    data {
      ...DashboardDropDown_category
    }
    entertainment {
      ...DashboardDropDown_category
    }
    ticketing {
      ...DashboardDropDown_category
    }
    billPayments {
      ...DashboardDropDown_category
    }
    electricity {
      ...DashboardDropDown_category
    }
    other {
      ...DashboardDropDown_category
    }
  }
}

fragment DashboardNegativeSummary_viewer on Viewer {
  report {
    reportNegativeTradingSummary(entityReference: $entityReference) {
      notTradedInLastDay
      notTradeInLast7Days
      notTradeInLast4Weeks
      notTradedSinceInception
      tradingWorseThanLastMonth
      tradingBalanceLess100
      totalSpokes
    }
  }
}

fragment DashboardProductsReport_report on DetailedSalesReport {
  entity
  categories {
    airtime {
      transactions {
        transactionCount
        transactionAmount
      }
    }
    data {
      transactions {
        transactionCount
        transactionAmount
      }
    }
    entertainment {
      transactions {
        transactionCount
        transactionAmount
      }
    }
    ticketing {
      transactions {
        transactionCount
        transactionAmount
      }
    }
    billPayments {
      transactions {
        transactionCount
        transactionAmount
      }
    }
    electricity {
      transactions {
        transactionCount
        transactionAmount
      }
    }
    other {
      transactions {
        transactionCount
        transactionAmount
      }
    }
  }
}

fragment DashboardProfitView_commissionSummary on CommissionSummary {
  spoke {
    account
  }
  current {
    realTime
    monthEnd
    cash
    total
  }
}

fragment DashboardSearch_account on DashboardAccount {
  __isDashboardAccount: __typename
  categories {
    category
    allZero
  }
}

fragment DashboardSummary_accountSummary on DashboardAccountSummary {
  __isDashboardAccountSummary: __typename
  name
  account
  availableBalance
  lastPaid {
    amount
    date
  }
}

fragment DashboardSummary_commissionSummary on CommissionSummary {
  ...DashboardProfitView_commissionSummary
}

fragment DashboardSummary_totalSales on DashboardCategorySales {
  yesterdaysSalesToDate
  currentMonthToDate
  lastMonthMonthToDate
  lastMonth
}

fragment DashboardViewDataModal_report on DetailedSalesReport {
  entity
  categories {
    airtime {
      categories {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
      totalRollup {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
    }
    data {
      categories {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
      totalRollup {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
    }
    billPayments {
      categories {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
      totalRollup {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
    }
    entertainment {
      categories {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
      totalRollup {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
    }
    ticketing {
      categories {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
      totalRollup {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
    }
    electricity {
      categories {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
      totalRollup {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
    }
    other {
      categories {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
      totalRollup {
        spoke
        spokeAcc
        email
        cellNumber
        isNull
        name
        key
        yesterdaysSalesToDate
        currentMonthToDate
        lastMonth
        lastMonthMonthToDate
      }
    }
  }
}

fragment Dashboard_viewer on Viewer {
  ...EntityCombobox_viewer
  ...DashboardDataViewer_viewer
  user {
    username
    email
    userTourComplete
    cellphoneNumber
    regions
    isHub
    roles {
      name
      id
    }
    loginCount {
      lastLogin
      lastWeek
      lastMonth
      lastYear
    }
    lastPrompt {
      id
      LastPromptTime
    }
    id
  }
  report {
    contact(entityReference: $entityReference) {
      cellNumber
      regionName
      contactName
      spoke {
        accountName
      }
    }
    detailedSalesReport(entityReference: $entityReference) {
      ...DashboardViewDataModal_report
    }
  }
  users {
    edges {
      node {
        username
        regions
        cellphoneNumber
        id
      }
    }
  }
}

fragment EntityCombobox_viewer on Viewer {
  linkedEntities(entityReference: $entityReference) {
    type
    name
    account
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityReference"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "kind": "Variable",
  "name": "entityReference",
  "variableName": "entityReference"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cellphoneNumber",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regions",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastMonth",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yesterdaysSalesToDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentMonthToDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastMonthMonthToDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cellNumber",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isNull",
    "storageKey": null
  },
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spoke",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spokeAcc",
    "storageKey": null
  },
  (v9/*: any*/),
  (v16/*: any*/)
],
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportSales",
    "kind": "LinkedField",
    "name": "categories",
    "plural": true,
    "selections": (v17/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportSales",
    "kind": "LinkedField",
    "name": "totalRollup",
    "plural": false,
    "selections": (v17/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportTransActions",
    "kind": "LinkedField",
    "name": "transactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionAmount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v19 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "DashboardCategorySales",
    "kind": "LinkedField",
    "name": "categories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allZero",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isDashboardAccount"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DashboardLastPaid",
        "kind": "LinkedField",
        "name": "lastPaid",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "DashboardAccountSummary",
    "abstractKey": "__isDashboardAccountSummary"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Dashboard_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "LinkedEntity",
            "kind": "LinkedField",
            "name": "linkedEntities",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userTourComplete",
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isHub",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LoginCount",
                "kind": "LinkedField",
                "name": "loginCount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastLogin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastWeek",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastYear",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LastPrompt",
                "kind": "LinkedField",
                "name": "lastPrompt",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "LastPromptTime",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "kind": "LinkedField",
            "name": "report",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "CommissionSummary",
                "kind": "LinkedField",
                "name": "commissionSummary",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "spoke",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfitCommission",
                    "kind": "LinkedField",
                    "name": "current",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "realTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "monthEnd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cash",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "endDate",
                    "variableName": "endDate"
                  },
                  (v3/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "startDate",
                    "variableName": "startDate"
                  }
                ],
                "concreteType": "DetailedSalesReportDateRange",
                "kind": "LinkedField",
                "name": "detailedSalesReportDateRange",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "HUBAcc",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "HUB",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "SpokeAcc",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Spoke",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "TotalSales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Airtime_Sales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Data_Sales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Electricity_Sales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Entertainment_Sales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Ticketing_Sales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Billpayments_Sales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "Other_Sales",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "DetailedSalesReport",
                "kind": "LinkedField",
                "name": "detailedSalesReport",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedSalesReportCategories",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailedSalesReportCategory",
                        "kind": "LinkedField",
                        "name": "airtime",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailedSalesReportCategory",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailedSalesReportCategory",
                        "kind": "LinkedField",
                        "name": "entertainment",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailedSalesReportCategory",
                        "kind": "LinkedField",
                        "name": "ticketing",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailedSalesReportCategory",
                        "kind": "LinkedField",
                        "name": "billPayments",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailedSalesReportCategory",
                        "kind": "LinkedField",
                        "name": "electricity",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailedSalesReportCategory",
                        "kind": "LinkedField",
                        "name": "other",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entity",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ReportNegativeTradingSummary",
                "kind": "LinkedField",
                "name": "reportNegativeTradingSummary",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notTradedInLastDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notTradeInLast7Days",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notTradeInLast4Weeks",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notTradedSinceInception",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tradingWorseThanLastMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tradingBalanceLess100",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalSpokes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ContactReport",
                "kind": "LinkedField",
                "name": "contact",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "regionName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "spoke",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "dashboard",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DashboardHubAccount",
                "kind": "LinkedField",
                "name": "hub",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DashboardHubAccount",
                "kind": "LinkedField",
                "name": "rollup",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DashboardSpokeAccount",
                "kind": "LinkedField",
                "name": "spokes",
                "plural": true,
                "selections": (v19/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ViewerUsersConnection",
            "kind": "LinkedField",
            "name": "users",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ViewerUsersEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c50db99f726008d8f8592f778e48137b",
    "id": null,
    "metadata": {},
    "name": "DashboardQuery",
    "operationKind": "query",
    "text": "query DashboardQuery(\n  $entityReference: String!\n  $startDate: Date!\n  $endDate: Date!\n) {\n  viewer {\n    ...Dashboard_viewer\n  }\n}\n\nfragment AccountSelector_viewer on Viewer {\n  user {\n    id\n    username\n    roles {\n      name\n      id\n    }\n  }\n}\n\nfragment DashboardDataBlock_category on DashboardCategorySales {\n  category\n  yesterdaysSalesToDate\n  currentMonthToDate\n  lastMonthMonthToDate\n  lastMonth\n  allZero\n}\n\nfragment DashboardDataViewer_viewer on Viewer {\n  ...AccountSelector_viewer\n  user {\n    roles {\n      name\n      id\n    }\n    id\n  }\n  report {\n    commissionSummary(entityReference: $entityReference) {\n      ...DashboardSummary_commissionSummary\n    }\n    detailedSalesReportDateRange(entityReference: $entityReference, startDate: $startDate, endDate: $endDate) {\n      HUBAcc\n      HUB\n      SpokeAcc\n      Spoke\n      TotalSales\n      Airtime_Sales\n      Data_Sales\n      Electricity_Sales\n      Entertainment_Sales\n      Ticketing_Sales\n      Billpayments_Sales\n      Other_Sales\n    }\n    detailedSalesReport(entityReference: $entityReference) {\n      ...DashboardDropDown_report\n      ...DashboardProductsReport_report\n      entity\n      categories {\n        airtime {\n          categories {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          totalRollup {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          transactions {\n            transactionCount\n            transactionAmount\n          }\n        }\n        data {\n          categories {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          totalRollup {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          transactions {\n            transactionCount\n            transactionAmount\n          }\n        }\n        entertainment {\n          categories {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          totalRollup {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          transactions {\n            transactionCount\n            transactionAmount\n          }\n        }\n        ticketing {\n          categories {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          totalRollup {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          transactions {\n            transactionCount\n            transactionAmount\n          }\n        }\n        billPayments {\n          categories {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          totalRollup {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          transactions {\n            transactionCount\n            transactionAmount\n          }\n        }\n        electricity {\n          categories {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          totalRollup {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          transactions {\n            transactionCount\n            transactionAmount\n          }\n        }\n        other {\n          categories {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          totalRollup {\n            isNull\n            name\n            key\n            yesterdaysSalesToDate\n            currentMonthToDate\n            lastMonthMonthToDate\n            lastMonth\n          }\n          transactions {\n            transactionCount\n            transactionAmount\n          }\n        }\n      }\n    }\n  }\n  ...EntityCombobox_viewer\n  ...DashboardNegativeSummary_viewer\n  dashboard(entityReference: $entityReference) {\n    hub {\n      account\n      ...DashboardSearch_account\n      ...DashboardSummary_accountSummary\n      categories {\n        category\n        ...DashboardDataBlock_category\n        ...DashboardSummary_totalSales\n      }\n    }\n    rollup {\n      account\n      ...DashboardSearch_account\n      ...DashboardSummary_accountSummary\n      categories {\n        category\n        ...DashboardDataBlock_category\n        ...DashboardSummary_totalSales\n      }\n    }\n    spokes {\n      account\n      ...DashboardSearch_account\n      ...DashboardSummary_accountSummary\n      categories {\n        category\n        ...DashboardDataBlock_category\n        ...DashboardSummary_totalSales\n      }\n    }\n  }\n}\n\nfragment DashboardDropDown_category on DetailedSalesReportCategory {\n  categories {\n    isNull\n    name\n    key\n    yesterdaysSalesToDate\n    currentMonthToDate\n    lastMonthMonthToDate\n    lastMonth\n  }\n  totalRollup {\n    isNull\n    name\n    key\n    yesterdaysSalesToDate\n    currentMonthToDate\n    lastMonthMonthToDate\n    lastMonth\n  }\n}\n\nfragment DashboardDropDown_report on DetailedSalesReport {\n  categories {\n    airtime {\n      ...DashboardDropDown_category\n    }\n    data {\n      ...DashboardDropDown_category\n    }\n    entertainment {\n      ...DashboardDropDown_category\n    }\n    ticketing {\n      ...DashboardDropDown_category\n    }\n    billPayments {\n      ...DashboardDropDown_category\n    }\n    electricity {\n      ...DashboardDropDown_category\n    }\n    other {\n      ...DashboardDropDown_category\n    }\n  }\n}\n\nfragment DashboardNegativeSummary_viewer on Viewer {\n  report {\n    reportNegativeTradingSummary(entityReference: $entityReference) {\n      notTradedInLastDay\n      notTradeInLast7Days\n      notTradeInLast4Weeks\n      notTradedSinceInception\n      tradingWorseThanLastMonth\n      tradingBalanceLess100\n      totalSpokes\n    }\n  }\n}\n\nfragment DashboardProductsReport_report on DetailedSalesReport {\n  entity\n  categories {\n    airtime {\n      transactions {\n        transactionCount\n        transactionAmount\n      }\n    }\n    data {\n      transactions {\n        transactionCount\n        transactionAmount\n      }\n    }\n    entertainment {\n      transactions {\n        transactionCount\n        transactionAmount\n      }\n    }\n    ticketing {\n      transactions {\n        transactionCount\n        transactionAmount\n      }\n    }\n    billPayments {\n      transactions {\n        transactionCount\n        transactionAmount\n      }\n    }\n    electricity {\n      transactions {\n        transactionCount\n        transactionAmount\n      }\n    }\n    other {\n      transactions {\n        transactionCount\n        transactionAmount\n      }\n    }\n  }\n}\n\nfragment DashboardProfitView_commissionSummary on CommissionSummary {\n  spoke {\n    account\n  }\n  current {\n    realTime\n    monthEnd\n    cash\n    total\n  }\n}\n\nfragment DashboardSearch_account on DashboardAccount {\n  __isDashboardAccount: __typename\n  categories {\n    category\n    allZero\n  }\n}\n\nfragment DashboardSummary_accountSummary on DashboardAccountSummary {\n  __isDashboardAccountSummary: __typename\n  name\n  account\n  availableBalance\n  lastPaid {\n    amount\n    date\n  }\n}\n\nfragment DashboardSummary_commissionSummary on CommissionSummary {\n  ...DashboardProfitView_commissionSummary\n}\n\nfragment DashboardSummary_totalSales on DashboardCategorySales {\n  yesterdaysSalesToDate\n  currentMonthToDate\n  lastMonthMonthToDate\n  lastMonth\n}\n\nfragment DashboardViewDataModal_report on DetailedSalesReport {\n  entity\n  categories {\n    airtime {\n      categories {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n      totalRollup {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n    }\n    data {\n      categories {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n      totalRollup {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n    }\n    billPayments {\n      categories {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n      totalRollup {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n    }\n    entertainment {\n      categories {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n      totalRollup {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n    }\n    ticketing {\n      categories {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n      totalRollup {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n    }\n    electricity {\n      categories {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n      totalRollup {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n    }\n    other {\n      categories {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n      totalRollup {\n        spoke\n        spokeAcc\n        email\n        cellNumber\n        isNull\n        name\n        key\n        yesterdaysSalesToDate\n        currentMonthToDate\n        lastMonth\n        lastMonthMonthToDate\n      }\n    }\n  }\n}\n\nfragment Dashboard_viewer on Viewer {\n  ...EntityCombobox_viewer\n  ...DashboardDataViewer_viewer\n  user {\n    username\n    email\n    userTourComplete\n    cellphoneNumber\n    regions\n    isHub\n    roles {\n      name\n      id\n    }\n    loginCount {\n      lastLogin\n      lastWeek\n      lastMonth\n      lastYear\n    }\n    lastPrompt {\n      id\n      LastPromptTime\n    }\n    id\n  }\n  report {\n    contact(entityReference: $entityReference) {\n      cellNumber\n      regionName\n      contactName\n      spoke {\n        accountName\n      }\n    }\n    detailedSalesReport(entityReference: $entityReference) {\n      ...DashboardViewDataModal_report\n    }\n  }\n  users {\n    edges {\n      node {\n        username\n        regions\n        cellphoneNumber\n        id\n      }\n    }\n  }\n}\n\nfragment EntityCombobox_viewer on Viewer {\n  linkedEntities(entityReference: $entityReference) {\n    type\n    name\n    account\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fa7eb669f571c921604ffa310c955d0e';
export default node;
